import styled from '@emotion/styled';
import { ComponentProps } from 'react';
import { typography } from '~/modules/Elements/cssMixins';

interface Props extends Omit<ComponentProps<typeof Container>, 'onChange'> {
  unit?: string;
  value: number;
  onChange: (newValue: number) => void;
  step?: number;
  disabled?: boolean;
}

function NumericInput({ unit = '', value, onChange, step = 50, disabled = false, className = '', ...props }: Props) {
  return (
    <Container className={`${className} shadow-focusable rounded-md`} {...props}>
      <Button
        onClick={() => onChange(value - step)}
        disabled={disabled}
        data-test="numeric-input-down"
        className="rounded-l-md">
        -
      </Button>
      <Value>
        <strong data-test="numeric-input-value">{value}</strong>
        {unit}
      </Value>
      <Button
        onClick={() => onChange(value + step)}
        disabled={disabled}
        data-test="numeric-input-up"
        className="rounded-r-md">
        +
      </Button>
    </Container>
  );
}
export default NumericInput;

const Button = styled.button`
  min-width: 50px;
  min-height: 46px;
  padding: 0 16px;
  border: 0;
  border-right: 1px solid var(--walky-border);
  background: var(--walky-surface-raised);
  color: var(--walky-ink);
  font-size: 24px;
  font-weight: 900;
  ${typography};

  &:last-child {
    border-right: 0;
    border-left: 1px solid var(--walky-border);
  }

  :disabled {
    opacity: 0.5;
  }
`;

const Value = styled.div`
  flex: 1;
  min-width: 82px;
  text-align: center;
  color: var(--walky-ink);
  font-size: 15px;
  font-weight: 800;
`;
const Container = styled.div`
  ${typography};
  display: flex;
  align-items: center;
  justify-self: center;
  overflow: hidden;
  border: 1px solid var(--walky-border);
  border-radius: 10px;
  background: var(--walky-canvas);
  box-shadow: var(--walky-shadow);
`;
